import { useEffect, useState } from 'react';
import { useUser } from '@/queries/useUser';
import { ADD_PRODUCT_CONFIGS, updateProductTypesEnabled } from '../constants/productTypes';
import type { ProductTypeConfig } from '../types/productType.types';
import type { ProductType } from '@/types/store';

export function useProductTypes() {
    const { user, isUserLoading } = useUser();
    const [productTypes, setProductTypes] = useState<ProductTypeConfig[]>(ADD_PRODUCT_CONFIGS);

    // Update product types based on user's active product types
    useEffect(() => {
        if (user?.active_product_types) {
            const updatedProductTypes = updateProductTypesEnabled(
                ADD_PRODUCT_CONFIGS,
                user.active_product_types as ProductType[]
            );
            setProductTypes(updatedProductTypes);
        }
    }, [user?.active_product_types]);

    return {
        productTypes,
        isLoading: isUserLoading,
    };
}
